export const BASED_ON_JSON = [
  { id: 1, label: 'Transaction Date' },
  { id: 2, label: 'Reflected At Bank' },
];

export const TYPE_JSON = [
  { id: 1, label: 'Month-wise' },
  { id: 2, label: 'Day-wise' },
];

export const USER_TYPE_JSON = [
  { id: -1, label: 'All' },
  { id: 1, label: 'CRO' },
  { id: 2, label: 'OGA' },
  { id: 3, label: 'Others' },
];

export const CREDITED_AC = [
  { id: -1, label: 'All' },
  { id: 1, label: 'N/A' },
  { id: 2, label: 'Indian A/C' },
  { id: 3, label: 'GCC A/C' },
];
export const MONTHS_WITHOUT_ALL = [
  {
    id: 1,
    name: 'January',
  },
  {
    id: 2,
    name: 'February',
  },
  {
    id: 3,
    name: 'March',
  },
  {
    id: 4,
    name: 'April',
  },
  {
    id: 5,
    name: 'May',
  },
  {
    id: 6,
    name: 'June',
  },
  {
    id: 7,
    name: 'July',
  },
  {
    id: 8,
    name: 'August',
  },
  {
    id: 9,
    name: 'September',
  },
  {
    id: 10,
    name: 'October',
  },
  {
    id: 11,
    name: 'November',
  },
  {
    id: 12,
    name: 'December',
  },
];

export const DaysOfMonth = Array.from({ length: 31 }, (_, i) => ({
  id: i + 1,
  name: `Day ${i + 1}`,
}));

const startYear = 2021;
const currentYear = new Date().getFullYear();
export const YEARS = Array.from({ length: currentYear - startYear + 1 }, (_, index) => ({
  id: index + startYear,
  name: index + startYear,
}));